import VerifyEmailContainer from '../components/VerifyEmail/VerifyEmailContainer';
import ResetPasswordFormContainer from '../components/ResetPasswordForm/ResetPasswordFormContainer';
import ConfirmWithdrawContainer from '../components/ConfirmWithdraw/ConfirmWithdrawContainer';
import DepositConfirmationModalContainer from '../components/DepositConfirmation/DepositConfirmationModalContainer';
import StandaloneLoginContainer from '../components/Login/StandaloneLoginFormContainer';
import VerifyAddressContainer from '../components/VerifyAddress/VerifyAddressContainer';
import VerifyDeviceContainer from '../components/VerifyDevice/VerifyDeviceContainer';
export var STAND_ALONE_COMPONENTS = {
  VerifyEmailContainer: VerifyEmailContainer,
  ResetPasswordNoAuthFormContainer: ResetPasswordFormContainer,
  ConfirmWithdrawContainer: ConfirmWithdrawContainer,
  DepositConfirmationContainer: DepositConfirmationModalContainer,
  StandaloneLoginContainer: StandaloneLoginContainer,
  VerifyAddressContainer: VerifyAddressContainer,
  VerifyDeviceContainer: VerifyDeviceContainer
};